/** New Journey module IDs — sync with backend Modules.cs and supabase/seed/modules.sql */
export const MODULES = {
  DASHBOARD: "/admin",
  PRODUCTS: "/admin/products",
  ORDERS: "/admin/orders",
  BILLING: "/admin/billing",
  INVENTORY: "/admin/inventory",
  PRINTERS: "/admin/printers",
  CUSTOMERS: "/admin/customers",
  SUPPORT: "/admin/support",
  REVIEWS: "/admin/reviews",
  BLOG: "/admin/blog",
  COUPONS: "/admin/coupons",
  ANALYTICS: "/admin/analytics",
  MEDIA: "/admin/media",
  ACTIVITY_LOGS: "/admin/activity",
  SETTINGS: "/admin/settings",
  ROLES: "/admin/roles",
  USERS: "/admin/users",
  B2B_DASHBOARD: "/admin/b2b",
  B2B_CATEGORIES: "/admin/b2b/categories",
  B2B_PRODUCTS: "/admin/b2b/products",
  B2B_CATALOG: "/admin/b2b/catalog",
  B2B_QUOTES: "/admin/b2b/quotes",
  B2B_DEALERS: "/admin/b2b/dealers",
  B2B_ANALYTICS: "/admin/b2b/analytics",
  B2B_SETTINGS: "/admin/b2b/settings",
  B2B_PORTAL: "/b2b",
  ACCOUNTS: "/admin/accounts",
  PAYMENT_CONFIGURATION: "/admin/payment-configuration",
  NOTIFICATION_CONFIGURATION: "/admin/notification-configuration",
  APPROVALS: "/admin/approvals",
  FORMS: "/admin/forms",
  ACCOUNT: "/account",
  ACCOUNT_ORDERS: "/account/orders",
  ACCOUNT_WISHLIST: "/account/wishlist",
  ACCOUNT_PROFILE: "/account/profile",
  ACCOUNT_SUPPORT: "/account/support",
  CHECKOUT: "/checkout",
  PAYMENT: "/pay",
  STOREFRONT: "/",
  CATALOG: "/products",
} as const;

export type ModuleId = (typeof MODULES)[keyof typeof MODULES];

export const FIELD_PREFIX = "flds_";
